module.exports = __webpack_public_path__ + "b744ca3d67b8016c892b0787830178b3.png";